import React, { useState } from 'react';
import OrangeButton from '../../buttons/orange-button';

const ZipModal = () => {
  const [open, setOpen] = useState(false);
  const [showZipModal, setShowZipModal] = useState(false);
  const [zipcodeInput, setZipcodeInput] = useState('');
  const [selectZipInput, setSelectZipInput] = useState('');
  function closeModals() {
    setOpen(!open);
    if (showZipModal) {
      setShowZipModal(false);
      return;
    }
  }

  return (
    <div>
      <div className={`relative w-full flex-1 hover:cursor-pointer`}>
        <div
          onClick={() => closeModals()}
          className="flex !h-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 "
        >
          <div className="flex flex-col gap-1">
            <p className="fredoka text-sm -tracking-[0.28px] text-[#012E33]">Type</p>
            <p className="fredoka text-base font-medium capitalize -tracking-[0.16px] text-[#012E33]">
              In person {selectZipInput}
            </p>
          </div>
          <img src="/images/icons/chevron-down-outline.svg" alt="" />
        </div>
        {open && (
          <div className="absolute z-50 w-full rounded-lg bg-white p-3 shadow-md">
            <ul className="flex flex-col gap-2">
              <li className="flex cursor-pointer flex-col gap-2 rounded-[4px] p-1.5 text-sm font-normal capitalize text-gray-900 transition-all hover:bg-gray-100">
                <p className="fredoka flex text-xl font-medium text-[#012E33]">Virtual</p>
                <p className="fredoka flex text-lg font-medium text-[#678285]">
                  Book Session Online
                </p>
              </li>
              <li
                className="flex cursor-pointer flex-col gap-2 rounded-[4px] p-1.5 text-sm font-normal capitalize text-gray-900 transition-all hover:bg-gray-100"
                onClick={() => {
                  setShowZipModal(true);
                  setOpen(false);
                }}
              >
                <p className="fredoka flex text-xl font-medium text-[#012E33]">In-person</p>
                <p className="fredoka flex text-lg font-medium text-[#678285]">
                  Meet Tutors In Person{' '}
                </p>
              </li>
            </ul>
          </div>
        )}
        {showZipModal && (
          <div className="absolute z-50 w-full rounded-lg bg-white p-3 shadow-md">
            <div className="flex flex-col gap-2">
              <div className="flex cursor-pointer flex-col gap-2 rounded-[4px] p-1.5 text-sm font-normal capitalize text-gray-900 transition-all hover:bg-gray-100">
                <p className="fredoka flex text-xl font-medium text-[#012E33]">
                  Enter Your Zip Code
                </p>
                <div
                  className={` flex items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3`}
                >
                  <input
                    type="number"
                    className="fredoka ml-3 w-full border-none bg-inherit font-medium leading-normal -tracking-[0.16px] text-[#678285] outline-none"
                    placeholder="Zip Code"
                    onChange={(e) => setZipcodeInput(e.target.value)}
                  />
                </div>
                <OrangeButton
                  onClick={() => {
                    setSelectZipInput(zipcodeInput);
                    setOpen(false);
                    setShowZipModal(false);
                  }}
                  label={'Submit'}
                  className="w-full"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZipModal;
